import { ContainerNoTopSpace, ContainerWebinarInner, Heading } from '@core/ui';
import { Link } from '@online-webinar/ui-frontend';
import { useTranslation } from 'react-i18next';

export const TestSuiteChooserPage = () => {
    const { t } = useTranslation();

    return (
        <ContainerNoTopSpace>
            <ContainerWebinarInner>
                <Heading variant="h1" classNames="mb-4 lg:mb-6 2xl:mb-8">
                    {t('TestSuite.PageHeading')}
                </Heading>
                <div className="grid md:grid-cols-2 gap-4 max-w-480 z-1">
                    <section className="flex flex-col bg-white rounded-lg p-4 md:p-6">
                        <Heading variant="h2" classNames="mb-2">
                            {t('TestSuite.Chooser.Camera.Title')}
                        </Heading>
                        <p className="mb-6 grow">{t('TestSuite.Chooser.Camera.Description')}</p>
                        <Link to="/test-suite/camera" variant="primary" classNames="self-start">
                            {t('TestSuite.Chooser.Camera.Link')}
                        </Link>
                    </section>
                    <section className="flex flex-col bg-white rounded-lg p-4 md:p-6">
                        <Heading variant="h2" classNames="mb-2">
                            {t('TestSuite.Chooser.Line.Title')}
                        </Heading>
                        <p className="mb-6 grow">{t('TestSuite.Chooser.Line.Description')}</p>
                        <Link to="/test-suite/line" variant="primary" classNames="self-start">
                            {t('TestSuite.Chooser.Line.Link')}
                        </Link>
                    </section>
                </div>
            </ContainerWebinarInner>
        </ContainerNoTopSpace>
    );
};
